﻿import { Component, OnInit, ViewChild } from '@angular/core';
import { RestService } from 'src/app/_services/rest.service';
import { Tabla, TablaComponent } from '../../tabla';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from 'src/app/_services/util.service';

@Component({ templateUrl: 'cargar.resultado.component.html' })
export class CargarResultadoComponent implements OnInit {

    data: any;

    categoriaDeporte: any;

    categoriaDeporteObject: any;

    anio: any;

    showFilter = false;

    sexo: any;

    sexoObject: any;

    data2: any;

    record: any;

    tabla: Tabla = {
        titulo: 'Posiciones',
        hideHeader: true,
        externalData: true,
        endPoint: '/rest-api/user/resultado',
        editable: true,
        nuevo: true,
        columnas: [
            {
                name: 'id',
                prop: 'id',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 75,
                hidden: true
            },
            {
                name: 'Puesto',
                prop: 'puesto',
                cell: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 75
            },
            {
                name: 'Alumno',
                prop: 'alumno',
                cell: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 300
            },
            {
                name: 'Casa',
                prop: 'alumno.casa',
                cell: 'nombre',
                editable: false,
                resizeable: true,
                sortable: true,
                casa: true,
                width: 100
            },
            {
                name: 'Valor',
                prop: 'valor',
                editable: true,
                resizeable: true,
                sortable: true,
                icon: true,
                width: 150,
                pattern: true
            }
        ]
    };

    @ViewChild(TablaComponent) tablaComponent: TablaComponent;

    postaPorCategoria: boolean = false;
    individual: boolean = false;
    compararContraRecords: boolean = true;
    minRecord: number = 0.5;
    maxRecord: number = 10;


    constructor(private restService: RestService, private route: ActivatedRoute, private utilService: UtilService) {
        this.route.queryParams.subscribe(params => {
            if (params['sexo']) {
                this.sexo = JSON.parse(params['sexo']);
                this.categoriaDeporte = JSON.parse(params['categoria']);
            } else {
                this.showFilter = true;
            }
            if (params['anio']) {
                this.anio = JSON.parse(params['anio']);
            } else {
                this.anio = this.currentYear();
            }
            this.restService.getParam('posta.por.categoria').subscribe(async (data) => {
                this.postaPorCategoria = data.valor.toUpperCase() === 'TRUE';
                await this.loadAll();                
            })
        });
    }

    ngOnInit() {
    }

    async loadAll() {
        this.restService.getAll('/rest-api/user/resultado/cargar').subscribe(data => {
            this.data = data;
            this.route.queryParams.subscribe(async (params) => {
                if (params['sexo']) {
                    this.sexo = JSON.parse(params['sexo']);
                    this.categoriaDeporte = JSON.parse(params['categoria']);
                    this.anio = JSON.parse(params['anio']);
                    this.individual = this.getCategoriaDeporte().deporte.individual;
                    if (!this.individual) {
                        this.tabla.columnas = this.tabla.columnas.filter(c => c.prop !== 'valor');
                    }
                    await this.searchAlumnos();
                }
            });
        });
    }

    async loadRecord(sex: String, cat: String) {
        if (sex && cat) {
            this.record = undefined;
            this.restService.getAll('/rest-api/user/record?sexo=' + sex +
                '&categoriaDeporte=' + cat).subscribe(data => {
                    this.record = data;
                });
        }
    }


    async searchAlumnos() {
        if (this.categoriaDeporte && this.sexo) {
            await this.loadRecord(this.sexo, this.categoriaDeporte);
            this.categoriaDeporteObject = undefined;
            this.sexoObject = undefined;
            this.restService.getAll('/rest-api/user/resultado/alumnos?sexo=' + this.sexo.toString() +
                '&categoriaDeporte=' + this.categoriaDeporte.toString() +
                '&anio=' + this.anio).subscribe(data => {
                    this.data2 = data;
                    if (this.tablaComponent) {
                        this.tablaComponent.allData = this.getDatos();
                        this.tablaComponent.rows = this.getDatos();
                    }
                });
        }
    }

    getDatos(): any {
        return {
            'data': this.data2.resultados,
            'alumno': this.data2.alumnos,
            'puesto': this.data2.puesto,
            'paramAnio': this.anio, //this.currentYear(),
            'paramCategoriaDeporte': this.getCategoriaDeporte(),
            'paramSexo': this.getSexo()
        };
    }

    getCategoriaDeporte(): any {
        //if (!this.categoriaDeporteObject) {
        this.data.categoriaDeporte.forEach(cat => {
            if (this.categoriaDeporte.toString() === cat.id.toString()) {
                this.categoriaDeporteObject = cat;
            }
        });
        //}
        return this.categoriaDeporteObject;
    }

    getSexo(): any {
        // if (!this.sexoObject) {
        this.data.sexo.forEach(cat => {
            if (this.sexo.toString() === cat.id.toString()) {
                this.sexoObject = cat;
            }
        });
        // }
        return this.sexoObject;
    }


    currentYear(): number {
        return (new Date()).getFullYear();
    }


    getGrado(categoria: any, sexo: any): string {
        return this.utilService.getGrado(categoria, sexo);
    }



}
